import React from 'react';

import { Alert, AlertProps } from 'antd';

type Props = { isKnowGuest: boolean, style?: AlertProps['style'] };

export function GuestAlert({ isKnowGuest, style }: Props) {
    const message = !isKnowGuest ? [
        'Não foi possível encontrar um visitante no sistema com o CPF informado.',
        'Por favor, preencha os campos abaixo para cadastrar o visitante.',
    ].join(' ') : [
        'O visitante já está cadastrado no sistema.',
        'Os campos abaixo são apenas para fins de confirmação e não podem ser alterados.',
    ].join(' ');

    const type = isKnowGuest ? 'info' : 'warning';

    return (
        <Alert
            message={message}
            type={type}
            style={style}
            showIcon
        />
    );
}
